import { DesignUpload } from '@/types';
import { postToDesignerService } from './fetchFromDesignerService';

interface MaskPayload {
  designId: string;
  targetShopId: string;
  transformX: number;
  transformY: number;
  maskWidth: number;
  maskHeight: number;
}

export const createMaskedDesign = (maskId: string, payload: MaskPayload) =>
  postToDesignerService<DesignUpload>(`masks/${maskId}/apply`, payload);
